import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'joi-nav-wrapper',
    template: `
<ng-container *ngIf="menuItems && !hideTabs">
  <div *ngFor="let item of menuItems" class="item"
    [ngClass]="{ active: selectedId === item, public: !!publicStyle, desktop: hiddenMobileItems.has(item), simple: simple }"
    (click)="selectItem.emit(item)"
    >
    <icon class="nav-icon" *ngIf="!!iconMap && iconMap[item]" [icon]="iconMap[item]" [title]="menuMap[item]"></icon>
    <ng-container *ngIf="!onlyIcons">{{ menuMap ? menuMap[item] || defaultMenuMap[item] : item }}</ng-container>
  </div>
</ng-container>
<div style="flex:1;"></div>
<ng-content></ng-content>

`,
    styleUrls: ['./joi-nav-wrapper.scss'],
    imports: [IconComponent, CommonModule],
    standalone: true,
})
export class JoiNavWrapper {
  @Input() menuItems: string[] = []
  @Input() simple: boolean = false
  @Input() menuMap: { [id: string]: string }
  @Input() defaultMenuMap: { [id: string]: string }
  @Input() iconMap: { [id:string]: string }
  @Input() selectedId
  @Input() publicStyle = false
  @Input() hideTabs = false
  @Input() onlyIcons = false
  @Input() hiddenMobileItems: Set<string> = new Set()
  @Output() selectItem: EventEmitter<any> = new EventEmitter()

}





